module.exports = __webpack_public_path__ + "img/staffPromotion.42000aef.png";